export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "society",
      layout: "dashboard",
    },
    path: "/societies",
    name: "societies",
    component: () => import("@/layouts/index/SocietyIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "societies",
          layout: "dashboard",
        },
        path: "index",
        name: "societies-index",
        component: () => import("@/views/societies/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer les informations de votre société",
          layout: "dashboard",
        },
        path: "create",
        name: "societies-create",
        component: () => import("@/views/societies/Create.vue"),
      },
    ],
  },
];
